'use strict';

class DunningView {
  constructor($http, $routeParams, $location, invoiceService, dunningService, Notification) {
    this.$http = $http;
    this.$location = $location;
    this.invoiceService = invoiceService;
    this.dunningService = dunningService;
    // this.salesLedgerService = salesLedgerService;
    this.Notification = Notification;

    this.number = $routeParams.number;
  }

  $onInit() {
    this.type = this.$location.search().type || '1Dunning';

    this.invoiceNumber = null;
    this.id = null;
    this.dunning = {};
    this.invoice = {};
    this.salesledger = {
      entries: []
    };
    this.load();
  }

  load() {
    this.dunningService.get(this.number)
      .then((resp) => {
        this.dunning = resp.data;
        this.invoiceNumber = resp.data.invoiceNumber;
        return resp.data.invoiceNumber;
      })
      .then((number) => {
        // console.log('  ** dunning load invoice get');
        // get invoice
        this.invoiceService.get(number)
          .then((invoice) => {
            this.invoice = invoice.data;
            return invoice.data;
          })
          .then((data) => {
            // get sl entries
            // this.salesLedgerService.getInvoiceEntries(data.number)
            //   .then((entries) => {
            //     this.salesledger.entries = entries.data;
            //   });
          });
      })
      .catch((err) => {
        if (err.status === 404) {
          this.$location.path('/beslutning-kreves');
        }
      });
  }

  cancelCollection() {
    this.$http.post(this.invoice._links.cancelCollection.uri)
      .then(() => {
        this.Notification.success('Regningen er flyttet tilbake til beslutning kreves');
        this.load();
      });
  }
}

DunningView.$inject = ['$http', '$routeParams', '$location', 'invoiceService', 'dunningService', 'Notification'];

const dunningView = {
  controller: DunningView,
  templateUrl: 'dunning/view.html'
};

angular
  .module('SendRegning')
  .component('dunningView', dunningView)
  .config(($routeProvider) => {
    $routeProvider
      .when('/purring/:number', {
        title: 'Vis purring',
        template: '<dunning-view />',
        secure: true
      });
  });
